import React, { Dispatch } from 'react';
import AwarenessChannels, {
  UserAwarenessChannelTypes,
} from '@zola-helpers/client/dist/es/redux/userAwareness/userAwarenessChannelConstants';
import {
  setChannelOtherText,
  toggleChannelChecked,
  UserAwarenessActionTypes,
} from '@zola-helpers/client/dist/es/redux/userAwareness/userAwarenessActions';
import type { UserAwarenessReducerStateType } from '@zola-helpers/client/dist/es/redux/userAwareness/userAwarenessReducer';

import { CheckboxField } from '../../../../Form/CheckboxField';
import OnboardStep, { OnboardStepProps } from '../../../OnboardStep';
import UserAwareness from '../../panes/UserAwareness';

import { Validations } from '../../../../Form/util';
import { getAwarenessChannelMap } from '../../../util/helpers';

import { ChannelOption, StyledInput, ChannelList } from './UserAwarenessStep.styles';

type FinishUpStepProps = Pick<
  OnboardStepProps,
  'portalContent' | 'hed' | 'dek' | 'nextButtonText'
> & {
  className?: string;
  state: UserAwarenessReducerStateType;
  dispatch: Dispatch<UserAwarenessActionTypes>;
};

const FinishUpStep = ({
  hed = 'One last thing. How did you hear about us?',
  dek,
  portalContent = <UserAwareness />,
  nextButtonText = 'Start planning',
  className,
  state,
  dispatch,
}: FinishUpStepProps): JSX.Element | null => {
  const { randomAwarenessChannelsOrder, awarenessChannels } = state;
  const awarenessChannelMap = getAwarenessChannelMap(true);
  const filteredOrder = randomAwarenessChannelsOrder.filter(
    (key) => !awarenessChannelMap[key].isDisabled
  );

  if (!filteredOrder || filteredOrder.length === 0) return null;

  const renderOptions = filteredOrder.map((channel: UserAwarenessChannelTypes) => {
    const { displayText } = awarenessChannelMap[channel];
    const isWriteIn = channel === AwarenessChannels.OTHER;
    if (isWriteIn) {
      return (
        <li key={channel}>
          <StyledInput
            name="user_awareness_channel_other_text"
            maxChars={50}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              setChannelOtherText(event.target.value)
            }
            placeholder="Other (please specify)"
            validate={[Validations.MAX_LENGTH_50]}
          />
        </li>
      );
    }

    return (
      <ChannelOption key={channel}>
        <CheckboxField
          checked={awarenessChannels[channel]}
          id={`user-awareness__${channel}--selected`}
          label={displayText}
          onChange={() => dispatch(toggleChannelChecked(channel, !awarenessChannels[channel]))}
        />
      </ChannelOption>
    );
  });

  return (
    <OnboardStep
      hed={hed}
      dek={dek}
      portalContent={portalContent}
      nextButtonText={nextButtonText}
      className={className}
    >
      <ChannelList>{renderOptions}</ChannelList>
    </OnboardStep>
  );
};

export default FinishUpStep;
